/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import type { TranslatorProps } from 'react-i18next';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//
import DetailsPanel from '../../../NotificationsReview/panels/DetailsPanel/DetailsPanel';
import styles from '../AssetCalibrationRequest/AssetCalibrationRequest.module.scss';

@translate()
export default class SupportRequest extends React.Component<*> {
  render(): React.Element<*> {
    const { t, data } = this.props;
    const { contact_details } = data.details;

    return (
      <React.Fragment>
        <DetailsPanel data={data} assetTitle={t('general:assets.labels.details')} />

        <div className={styles['list-container']}>
          <b>{t('general:notifications.request-support')}</b>
          <ul>
            <li>
              {t('general:labels.i_want_help')}: {data.details.help_with[0]}
            </li>
          </ul>
        </div>
        <div className={styles['list-container']}>
          <b>{t('general:labels.comments')}</b>
          <ul>
            <li>{data.details.comments}</li>
          </ul>
        </div>
        <div className={styles['list-container']}>
          <b>{t('general:labels.contact_details')}</b>
          <ul>
            <li>
              {t('general:labels.contact_name')}: {contact_details.name}
            </li>
            <li>
              {t('general:labels.contact_email')}: {contact_details.email}
            </li>
          </ul>
          <div className={styles['list-container']}>
            <b>{t('general:trading_account_s')}:</b>
            {contact_details.accounts.map(item => {
              return (
                <React.Fragment key={item.id}>
                  <div>
                    {t('general:trading_accounts.labels.name')}: {item.name}
                  </div>
                  <div>
                    {t('general:trading_accounts.labels.code')}: {item.account_no}
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
